// src/sections/CheckScontrino.jsx
import React, { useState, useEffect } from "react";
import { fetchListPuntiVenditaOfferte } from "../utilis/apiService";
import { postComuniOfferte, postOfferte } from "../utilis/apiSend";
import { useSearchParams } from "react-router-dom";
import PrimoPrezzo from "../img/PrimoPrezzo.png";
import OffersGrid from "../components/OffersGrid";

import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';

const CheckScontrino = ({ contenuti }) => {
  const [searchParams, setSearchParams] = useSearchParams();

  // 1) Leggo dalla query string lo slug e lo “de-slugifico” (hyphen → spazio)
  const slugCity   = searchParams.get("city")   || "";
  const slugPvCode = searchParams.get("pvCode") || "";
  const initialCity   = slugCity   ? slugCity.replace(/-/g, " ") : "";
  const initialPvCode = slugPvCode;

  // 2) Stati
  const [pvList, setPvList]       = useState([]);
  const [loadingPv, setLoadingPv] = useState(true);
  const [errorPv, setErrorPv]     = useState(null);

  const [selectedCity, setSelectedCity]     = useState(initialCity);
  const [pvSedi, setPvSedi]                 = useState([]);
  const [selectedPvCode, setSelectedPvCode] = useState(initialPvCode);

  const [offerte, setOfferte]       = useState([]);
  const [volantini, setVolantini]       = useState([]);
  const [modalImage, setModalImage] = useState(null);

  const [loadingEst, setLoadingEst] = useState(false);
  const [errorEst, setErrorEst]     = useState(null);

  const defaultCenter = { lat: 41.125, lng: 16.87 };
  const [center, setCenter] = useState(defaultCenter);

  const currentPv = pvList.find(pv => pv.codice === selectedPvCode);
  const displayAddress = currentPv
    ? `${currentPv.indirizzo}, ${currentPv.citta}`
    : "";

  const first = Array.isArray(contenuti)
    ? contenuti[0]
    : Object.values(contenuti)[0];
  const { sottotitolo_it, descrizione_it } = first;

  // 3) Sincronizzo URL ←→ stato, slugificando la città
  useEffect(() => {
    const params = {};
    if (selectedCity) {
      // trasforma "Polignano a Mare" → "Polignano-a-Mare"
      const slug = selectedCity.trim().replace(/\s+/g, "-");
      params.city = slug;
    }
    if (selectedPvCode) {
      params.pvCode = selectedPvCode;
    }
    setSearchParams(params, { replace: true });
  }, [selectedCity, selectedPvCode, setSearchParams]);

  // 4) Carico lista punti vendita
  useEffect(() => {
    fetchListPuntiVenditaOfferte()
      .then(data => setPvList(data))
      .catch(() => setErrorPv("Non riesco a caricare i punti vendita"))
      .finally(() => setLoadingPv(false));
  }, []);

  // 5) Carico sedi quando cambia città
  useEffect(() => {
    setPvSedi([]);
    if (!selectedCity) return;

    setLoadingEst(true);
    postComuniOfferte(selectedCity)
      .then(setPvSedi)
      .catch(() => setErrorEst("Errore recupero sedi"))
      .finally(() => setLoadingEst(false));
  }, [selectedCity]);

  // 6) Carico offerte quando cambia pvCode
  useEffect(() => {
    setOfferte([]);
    setCenter(defaultCenter);
    if (!selectedPvCode) return;

    setLoadingEst(true);
    postOfferte(selectedPvCode)
      .then(data => {
        setOfferte(data.list || [])
        setVolantini(!data.volantino ? [] : data.volantino)
      })
      .catch(() => setErrorEst("Errore recupero offerte"))
      .finally(() => setLoadingEst(false));
  }, [selectedPvCode]);

  return (
    <section style={{ marginBottom: 100, padding: "64px 0" }}>
      <div className="container">
        {/* Intro */}
        <div className="row text-center mb-3">
          <div className="col-12 text-14-4">{sottotitolo_it}</div>
        </div>
        <div className="row text-center mb-4">
          <div className="col-12 text-16 fw-bold">{descrizione_it}</div>
        </div>

        {/* Selezione città e sede */}
        <div className="row g-2 mb-5">
          <div className="col-12 col-md-6">
            {loadingPv ? (
              <p>Caricamento punti vendita…</p>
            ) : errorPv ? (
              <p className="text-danger">{errorPv}</p>
            ) : (
              <select
                className="form-select py-2"
                value={selectedCity}
                onChange={e => {
                  setSelectedCity(e.target.value);
                  setSelectedPvCode(""); // reset solo quando cambiano città
                }}
              >
                <option value="">Seleziona la città</option>
                {[...new Set(pvList.map(pv => pv.citta))].map(city => (
                  <option key={city} value={city}>
                    {city.charAt(0).toUpperCase() + city.slice(1).toLowerCase()}
                  </option>
                ))}
              </select>
            )}
          </div>

          {pvSedi.length > 0 && (
            <div className="col-12 col-md-6">
              <select
                className="form-select py-2"
                value={selectedPvCode}
                onChange={e => setSelectedPvCode(e.target.value)}
              >
                <option value="">Seleziona il punto vendita</option>
                {pvSedi.map(pv => (
                  <option key={pv.codice} value={pv.codice}>
                    {pv.indirizzo.charAt(0).toUpperCase() +
                      pv.indirizzo.slice(1).toLowerCase()} - {pv.insegna.charAt(0).toUpperCase() +
                      pv.insegna.slice(1).toLowerCase()}
                  </option>
                ))}
              </select>
            </div>
          )}
        </div>

        {volantini.length>0 &&(
          <div id='black-swiper' style={{marginBottom:100}} className="mySwiper volantini"> 
              <Swiper
              modules={[Navigation]}
              spaceBetween={20}
              navigation
              breakpoints={{
                0: { slidesPerView: 1 },
                640: { slidesPerView: 2 },
                1024: { slidesPerView: 4 }
              }}
            >
              {volantini.map((item, index) => (
                <SwiperSlide key={index}>
                  <img
                    src={item.url_immagine}
                    alt={`volantino ${index + 1}`}
                    style={{ width: '100%', maxHeight: 500, borderRadius: '12px', cursor: 'pointer' }}
                    onClick={() => setModalImage(item.url_immagine)}
                  />
                </SwiperSlide>
              ))}
            </Swiper>
            </div>
        )}

          {modalImage && (
          <div
            onClick={() => setModalImage(null)}
            style={{
              position: 'fixed',
              top: 0, left: 0, right: 0, bottom: 0,
              backgroundColor: 'rgba(0, 0, 0, 0.8)',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              zIndex: 1000,
              cursor: 'zoom-out'
            }}
          >
            <img
              src={modalImage}
              alt="ingrandita"
              style={{ maxWidth: '90%', maxHeight: '90%', borderRadius: '12px' }}
            />
          </div>
        )}

        {/* Offerte */}
        {offerte.length > 0 && (
          <div className="mt-4">
            <div className="text-center mb-4">
              <h2>SELEZIONE DI ARTICOLI OFFERTE SPECIALI</h2>
            </div>
            <OffersGrid offers={offerte} />
          </div>
        )}

        {loadingEst && (
          <div style={{ backgroundColor: "white", height: "100vh" }} />
        )}

        {/* Nessuna offerta */}
        {!loadingEst &&
          !errorEst &&
          selectedPvCode &&
          offerte.length === 0 && (
            <p>Nessuna offerta trovata per questo punto vendita.</p>
          )}
      </div>
    </section>
  );
};

export default CheckScontrino;
